/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the PreviewIncidentReportFootageDto interface.
 */
export function instanceOfPreviewIncidentReportFootageDto(value) {
    let isInstance = true;
    return isInstance;
}
export function PreviewIncidentReportFootageDtoFromJSON(json) {
    return PreviewIncidentReportFootageDtoFromJSONTyped(json, false);
}
export function PreviewIncidentReportFootageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'previewUrl': !exists(json, 'previewUrl') ? undefined : json['previewUrl'],
    };
}
export function PreviewIncidentReportFootageDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'thumbnailUrl': value.thumbnailUrl,
        'previewUrl': value.previewUrl,
    };
}
